module.exports = __webpack_public_path__ + "img/logo_sicepat.1958e9cf.png";